module.exports = __webpack_public_path__ + "img/fedex.fb94e1d5.png";